import { useSelector, useDispatch } from 'react-redux';
import {
  changeDateRange,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  clearExtraFilter,
  setFeatureFilter,
  setExtraFilter,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  getScoreCardConfigData,
  clearLobTeamAgent,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleLobAllFilterChange,
  handleAllTeamFilterChange,
  handleAllAgentFilterChange,
  handleRemoveMultipleAddcolumnFilterDataFromApplied,
  onchangeSearch,
  handlecloumnstore,
  setSelectedDatafromParent
} from 'store/ScoreCardFilter';
import { selectorForSelectedFilter } from 'store/ScoreCardFilter/selector';

function useScoreCardFilter() {
  const dispatch = useDispatch();

  const dateRange = useSelector((state) => state.filter.rangeDate),
    LOB = useSelector((state) => state.filter?.LOB),
    selectedLOB = useSelector((state) => state.filter.selected.LOB),
    ui = useSelector((state) => state?.filter.ui),
    LOBTeam = useSelector((state) => state.filter?.LOBTeam),
    LOBTeamAgent = useSelector((state) => state?.filter?.LOBTeamAgent),
    flag = useSelector((state) => state.filter.flag),
    filter = useSelector((state) => state.filter.data),
    filters = useSelector((state) => state.filter.data?.extra_filter),
    appliedExtraFilters = useSelector((state) => state.filter.extra_filter),
    appliedFeatureFilters = useSelector((state) => state.filter.features_filter),
    features_filter = useSelector((state) => state.filter.data?.feature_filter),
    selectedFilter = useSelector(selectorForSelectedFilter),
    searchText = useSelector((state) => state.filter?.searchText),
    // selectedFilter = useSelector((state) => ({
    //   LOB: state.filter.LOB,
    //   LOBTeam: state.filter.LOBTeam,
    //   LOBTeamAgent: state.filter.LOBTeamAgent
    // })),
    selectedFields = useSelector((state) => state.filter.selected?.fields),
    selectedRowFilterFields = useSelector((state) => state.filter.selected?.rowFilter),
    fields = useSelector((state) => state.filter.fields),
    call_duration = useSelector((state) => state.filter.data?.extra_filter?.call_duration),
    tenure = useSelector((state) => state.filter.data?.extra_filter?.tenure),
    shift = useSelector((state) => state.filter.data?.extra_filter?.shift),
    direction = useSelector((state) => state.filter.data?.extra_filter?.direction),
    skill_set = useSelector((state) => state.filter.data?.extra_filter?.skill_set),
    tagging_feature = useSelector((state) => state.filter.data?.extra_filter?.tagging_feature),
    exo_phone = useSelector((state) => state.filter.data?.extra_filter?.exo_phone),
    column = useSelector((state) => state.filter?.column);

  // fieldsConfig = useSelector((state) => state.filter.fields_config);

  const changeDateRangeAction = (params) => dispatch(changeDateRange(params)),
    handleLobFilterChangeAction = (params) => dispatch(handleLobFilterChange(params)),
    handleTeamFilterChangeAction = (params) => dispatch(handleTeamFilterChange(params)),
    handleAgentFilterChangeAction = (params) => dispatch(handleAgentFilterChange(params)),
    handleSetExtraFilterDataAction = (params) => dispatch(handleSetExtraFilterData(params)),
    handleRemoveExtraFilterDataAction = (params) => dispatch(handleRemoveExtraFilterData(params)),
    handleSetMultipleExtraFilterDataAction = (params) => dispatch(handleSetMultipleExtraFilterData(params)),
    handleRemoveMultipleExtraFilterDataAction = (params) => dispatch(handleRemoveMultipleExtraFilterData(params)),
    handleSetMultipleFeatureFilterDataAction = (params) => dispatch(handleSetMultipleFeatureFilterData(params)),
    handleRemoveFeatureExtraFilterDataAction = (params) => dispatch(handleRemoveFeatureExtraFilterData(params)),
    handleRemoveMultipleExtraFilterDataFromAppliedAction = (params) => dispatch(handleRemoveMultipleExtraFilterDataFromApplied(params)),
    handleChangeAddtionalFieldsAction = (params) => dispatch(handleChangeAddtionalFields(params)),
    handleChangeAddtionalSubFieldsAction = (params) => dispatch(handleChangeAddtionalSubFields(params)),
    setFeatureFilterAction = () => dispatch(setFeatureFilter()),
    handleRemoveMultipleAddcolumnFilterDataFromAppliedAction = (params) =>
      dispatch(handleRemoveMultipleAddcolumnFilterDataFromApplied(params)),
    setExtraFilterAction = () => dispatch(setExtraFilter()),
    clearExtraFilterAction = () => dispatch(clearExtraFilter()),
    clearLobTeamAgentAction = () => dispatch(clearLobTeamAgent()),
    getScoreCardConfigDataAction = (params) => dispatch(getScoreCardConfigData(params)),
    handleLobAllFilterChangeAction = () => dispatch(handleLobAllFilterChange()),
    handleAllTeamFilterChangeAction = () => dispatch(handleAllTeamFilterChange()),
    handleAllAgentFilterChangeAction = () => dispatch(handleAllAgentFilterChange()),
    onchangeSearchAction = (params) => dispatch(onchangeSearch(params)),
    handlecloumnstoreAction = (params) => dispatch(handlecloumnstore(params)),
    setSelectedDatafromParentAction = (params) => dispatch(setSelectedDatafromParent(params));

  return {
    // state of Filter
    dateRange,
    LOB,
    ui,
    LOBTeam,
    LOBTeamAgent,
    flag,
    filter,
    filters,
    features_filter,
    selectedFilter,
    selectedFields,
    selectedRowFilterFields,
    call_duration,
    tenure,
    shift,
    direction,
    skill_set,
    tagging_feature,
    exo_phone,
    fields,
    // fieldsConfig,
    appliedExtraFilters,
    appliedFeatureFilters,
    selectedLOB,
    searchText,
    column,

    // Action of Filter

    getScoreCardConfigDataAction,
    changeDateRangeAction,
    handleLobFilterChangeAction,
    handleTeamFilterChangeAction,
    handleAgentFilterChangeAction,
    handleChangeAddtionalFieldsAction,
    handleChangeAddtionalSubFieldsAction,
    handleSetExtraFilterDataAction,
    handleRemoveExtraFilterDataAction,
    handleSetMultipleExtraFilterDataAction,
    handleRemoveMultipleExtraFilterDataAction,
    handleSetMultipleFeatureFilterDataAction,
    handleRemoveFeatureExtraFilterDataAction,
    handleRemoveMultipleExtraFilterDataFromAppliedAction,
    handleRemoveMultipleAddcolumnFilterDataFromAppliedAction,
    setFeatureFilterAction,
    setExtraFilterAction,
    clearExtraFilterAction,
    clearLobTeamAgentAction,
    handleLobAllFilterChangeAction,
    handleAllTeamFilterChangeAction,
    handleAllAgentFilterChangeAction,
    onchangeSearchAction,
    handlecloumnstoreAction,
    setSelectedDatafromParentAction
  };
}

export default useScoreCardFilter;
